var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllToolsBrand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11373_298059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4935 5.66797H6.49349C6.03325 5.66797 5.66016 6.04106 5.66016 6.5013V11.5013C5.66016 11.9616 6.03325 12.3346 6.49349 12.3346H11.4935C11.9537 12.3346 12.3268 11.9616 12.3268 11.5013V6.5013C12.3268 6.04106 11.9537 5.66797 11.4935 5.66797Z",
    stroke: "#6B57FF",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4935 5.66797H6.49349C6.03325 5.66797 5.66016 6.04106 5.66016 6.5013V11.5013C5.66016 11.9616 6.03325 12.3346 6.49349 12.3346H11.4935C11.9537 12.3346 12.3268 11.9616 12.3268 11.5013V6.5013C12.3268 6.04106 11.9537 5.66797 11.4935 5.66797Z",
    stroke: "#6B57FF",
    strokeOpacity: 0.2,
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4935 15.668H6.49349C6.03325 15.668 5.66016 16.0411 5.66016 16.5013V21.5013C5.66016 21.9616 6.03325 22.3346 6.49349 22.3346H11.4935C11.9537 22.3346 12.3268 21.9616 12.3268 21.5013V16.5013C12.3268 16.0411 11.9537 15.668 11.4935 15.668Z",
    stroke: "#6B57FF",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4935 15.668H6.49349C6.03325 15.668 5.66016 16.0411 5.66016 16.5013V21.5013C5.66016 21.9616 6.03325 22.3346 6.49349 22.3346H11.4935C11.9537 22.3346 12.3268 21.9616 12.3268 21.5013V16.5013C12.3268 16.0411 11.9537 15.668 11.4935 15.668Z",
    stroke: "#6B57FF",
    strokeOpacity: 0.2,
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4935 5.66797H16.4935C16.0332 5.66797 15.6602 6.04106 15.6602 6.5013V11.5013C15.6602 11.9616 16.0332 12.3346 16.4935 12.3346H21.4935C21.9537 12.3346 22.3268 11.9616 22.3268 11.5013V6.5013C22.3268 6.04106 21.9537 5.66797 21.4935 5.66797Z",
    stroke: "#6B57FF",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4935 5.66797H16.4935C16.0332 5.66797 15.6602 6.04106 15.6602 6.5013V11.5013C15.6602 11.9616 16.0332 12.3346 16.4935 12.3346H21.4935C21.9537 12.3346 22.3268 11.9616 22.3268 11.5013V6.5013C22.3268 6.04106 21.9537 5.66797 21.4935 5.66797Z",
    stroke: "#6B57FF",
    strokeOpacity: 0.2,
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6602 15.668H22.3268",
    stroke: "#6B57FF",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6602 15.668H22.3268",
    stroke: "#6B57FF",
    strokeOpacity: 0.2,
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 19H22.3333",
    stroke: "#6B57FF",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 19H22.3333",
    stroke: "#6B57FF",
    strokeOpacity: 0.2,
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6602 22.332H22.3268",
    stroke: "#6B57FF",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6602 22.332H22.3268",
    stroke: "#6B57FF",
    strokeOpacity: 0.2,
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11373_298059"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllToolsBrand);
export default __webpack_public_path__ + "static/media/all-tools-brand.08a89022.svg";
export { ForwardRef as ReactComponent };